// organization store inner constants

export const ACT_DETAILS = 'detailsLoad';

export const MUT_DETAILSSET = 'detailsSet';
export const MUT_DETAILSCLEAR = 'detailsClear';
export const MUT_MYORGSET = 'myOrgSet';
export const MUT_MYORGCLEAR = 'myOrgClear';

export const GET_DETAILS = 'detailsGet';
export const GET_MYORG = 'myOrgGet';
